import { useRequirePermissions } from '@/shared/hooks';
import { Page } from '@/shared/ui/page';
import { TabsComponent } from '@noorden-insurtech/alba-design-system';
import { useParams } from '@tanstack/react-router';
import { BrokerHeader } from './broker-header.component';
import { BrokerProductsList } from './broker-products-list.component';
import { BrokerUsersList } from './broker-users-list.component';

export function BrokersIdPage() {
  const params = useParams({ strict: false });
  const id = params.id as string;
  const { hasPermission: canViewProducts } = useRequirePermissions({
    permissions: ['parties.brokers.products.read'],
  });
  const { hasPermission: canViewUsers } = useRequirePermissions({
    permissions: ['parties.brokers.users.read'],
  });

  const tabs = [
    ...(canViewUsers
      ? [
          {
            value: 'tab1',
            label: 'Usuários',
            content: <BrokerUsersList brokerId={id} />,
          },
        ]
      : []),
    ...(canViewProducts
      ? [
          {
            value: 'tab2',
            label: 'Produtos',
            content: <BrokerProductsList brokerId={id} />,
          },
        ]
      : []),
  ];

  const defaultTab = tabs[0]?.value ?? 'tab2';

  if (tabs.length === 0) {
    return (
      <Page.Root>
        <Page.Breadcrumb
          items={[
            { label: 'Página Inicial', href: '/dashboard' },
            { label: 'Corretores', href: '/brokers' },
            { label: 'Detalhes do Corretor', active: true },
          ]}
        />
        <BrokerHeader brokerId={id} />
      </Page.Root>
    );
  }

  return (
    <Page.Root>
      <Page.Breadcrumb
        items={[
          { label: 'Página Inicial', href: '/dashboard' },
          { label: 'Corretores', href: '/brokers' },
          { label: 'Detalhes do Corretor', active: true },
        ]}
      />

      <BrokerHeader brokerId={id} />

      <TabsComponent.Root defaultValue={defaultTab} className='w-full mt-2'>
        <TabsComponent.List className='w-full flex'>
          {tabs.map(tab => (
            <TabsComponent.Trigger
              key={tab.value}
              value={tab.value}
              className='flex-1'
            >
              {tab.label}
            </TabsComponent.Trigger>
          ))}
          <TabsComponent.Indicator />
        </TabsComponent.List>

        {tabs.map(tab => (
          <TabsComponent.Content key={tab.value} value={tab.value}>
            {tab.content}
          </TabsComponent.Content>
        ))}
      </TabsComponent.Root>
    </Page.Root>
  );
}
